import React from "react";

const LeaderBoards = () => {
  return <div>LeaderBoards</div>;
};

export default LeaderBoards;
